import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import { getUserCanOrderFromCustomLists } from 'entities/User/model/selectors/userPermissionsSeletors';
import { getRouteOrdersAddItemsCategories } from 'shared/const/router';
import { OrderAddItemsLists } from 'widgets/OrderAddItemsLists';

export const OrderAddItemPageLists = () => {
    const location = useLocation();
    const canOrderFromLists = useSelector(getUserCanOrderFromCustomLists);

    if (!canOrderFromLists) {
        return (
            <Navigate
                to={getRouteOrdersAddItemsCategories()}
                state={location.state}
                replace
            />
        );
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                minHeight: 0,
                height: '100%',
            }}
        >
            <OrderAddItemsLists />
        </Box>
    );
};
